import styled, { css } from "styled-components";

/* full-bleed pe lățimea viewport-ului */
export const CarouselWrap = styled.div`
  position: relative;
  width: 100vw;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
  padding: 28px 0 56px;
  user-select: none;
  background: transparent;
`;

/* center-mode cu peek MARE:
   - Desktop: slide ≈ 60vw (se văd mult cele laterale)
   - Mobile:  slide ≈ 78vw (și mai mult peek)
*/
export const CarouselInner = styled.div`
  --slide: 60vw; /* lățimea vizibilă a unui slide pe desktop */
  --gap: 4px; /* „dunga” dintre poze */
  --index: ${(p) => p.$index || 0};

  display: flex;
  align-items: center;
  gap: var(--gap);
  padding: 0 calc((100vw - var(--slide)) / 2);
  transition: transform 0.55s ease;
  transform: translateX(calc(-1 * var(--index) * (var(--slide) + var(--gap))));

  ${(p) =>
    p.$dragging &&
    css`
      transition: none;
      cursor: grabbing;
    `}

  @media (max-width: 1024px) {
    --slide: 66vw;
  }
  @media (max-width: 768px) {
    --slide: 78vw;
    --gap: 4px;
  }
`;

/* toate au aceeași formă, nu mai sunt lungite:
   - folosim aspect-ratio pentru proporție frumoasă
   - activul puțin mai mare (scale 1), lateralele micșorate (0.92)
*/
export const CarouselItem = styled.div`
  flex: 0 0 var(--slide);
  background: #e6e6e6; /* se vede ca o dungă între poze prin gap */
  border-radius: 14px;
  overflow: hidden;
  transform: scale(0.92);
  opacity: 0.8;
  transition: transform 0.35s ease, opacity 0.35s ease;

  ${(p) =>
    p.$active &&
    css`
      transform: scale(1);
      opacity: 1;
      z-index: 2;
      box-shadow: 0 10px 26px rgba(0, 0, 0, 0.2);
    `}

  /* imaginea ocupă complet cardul, păstrând proporția */
  img {
    display: block;
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9; /* PROPORȚIA — poți schimba 3/2 sau 4/3 */
    object-fit: cover;
  }

  @media (max-width: 768px) {
    border-radius: 12px;
    img {
      aspect-ratio: 4 / 3;
    } /* pe telefon un pic mai „înalt” */
  }
`;

/* săgeți jos, micuțe, centrate */
export const ArrowsWrap = styled.div`
  position: absolute;
  left: 50%;
  bottom: 12px;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 5;
`;

export const ArrowBtn = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
  font-size: 18px;
  display: grid;
  place-items: center;
  cursor: pointer;

  &:hover {
    background: #fff;
  }
  &:active {
    transform: scale(0.95);
  }
`;
